import script from "./MovieBlockGhost.vue?vue&type=script&setup=true&lang=js"
export * from "./MovieBlockGhost.vue?vue&type=script&setup=true&lang=js"

import "./MovieBlockGhost.vue?vue&type=style&index=0&id=62c9c4ec&scoped=true&lang=css"

import exportComponent from "/cbx/htdocs/cineweb-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62c9c4ec"]])

export default __exports__